import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[72px] flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2.5 cursor-pointer"
            aria-label="黑料网社首页"
          >
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-fire-line text-xl"></i>
            </span>
            <span className="leading-tight">
              <span
                className={`block text-xl font-script tracking-wide ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                黑料网社
              </span>
              <span
                className={`block text-[10px] tracking-[0.28em] uppercase ${
                  solid ? "text-foreground-500" : "text-background-200"
                }`}
              >
                Gossip Hub
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => {
              const active =
                link.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                    solid
                      ? active
                        ? "text-primary-700 bg-primary-100/70 font-medium"
                        : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                      : active
                        ? "text-background-50 bg-background-50/20 font-medium"
                        : "text-background-100 hover:bg-background-50/15"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/hot"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-fill"></i>
              逛热帖榜
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              className={`md:hidden w-10 h-10 rounded-md flex items-center justify-center transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-800 hover:bg-background-100"
                  : "text-background-50 hover:bg-background-50/15"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pt-2 pb-4">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="px-3 py-3 text-base text-foreground-800 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/hot"
              className="mt-2 px-3 py-3 rounded-md text-center text-base font-medium bg-primary-500 text-background-50"
            >
              逛热帖榜
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}